export default __webpack_public_path__ + "static/media/check-list.svg";